<script context="module">
  // context="module" makes this exportable
  export const WIDTH = 40;
</script>

<script>
  import { fly } from 'svelte/transition';
  import { quintIn, quintOut } from 'svelte/easing';

  import { blurOnClick } from '../../../../../js/blurOnClick';

  export let direction = 'right';

  // arrow buttons will "fly" in from the sides of
  // the nav when they appear, see in:fly & out:fly below
  $: flyX = WIDTH * (direction === 'right' ? 1 : -1);
</script>

<!--
  re: tabindex="-1"
  It's unnecessary for these arrows to be tab focusable,
  because the image links themselves are focusable.
  Focusing to the arrows would actually interrupt the 
  tab focus flow of the natural document order.
  We'll leave the arrows visible though as indicators
  that there is more content to tab through. 
  (And, of course, they are still touch/click enabled)
-->
<button
  on:click
  use:blurOnClick
  tabindex="-1"
  class="ArrowButton {direction}"
  style="width: {WIDTH}px;"
  aria-label="arrow button {direction}"
  in:fly={{ duration: 100, x: flyX, opacity: 0, easing: quintOut }}
  out:fly={{ duration: 100, x: flyX, opacity: 0, easing: quintIn }}
></button>

<style>.ArrowButton {
  cursor: pointer;
  appearance: none;
  z-index: 1;
  display: block;
  position: absolute;
  top: 0;
  height: 100%;
  border: 0;
  outline: none;
  background-color: transparent !important;
}
.ArrowButton::after {
  content: "";
  display: block;
  position: absolute;
  width: 8px;
  height: 8px;
  right: 50%;
  top: 50%;
  border-style: solid;
  border-width: 0;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-color: var(--color-text, #1a1a1a);
}

.left {
  left: 0;
  background: linear-gradient(90deg, var(--color-background, #fff) 5%, rgba(var(--color-background-rgb, 255, 255, 255), 0.65) 75%, rgba(var(--color-background-rgb, 255, 255, 255), 0) 100%);
}
.left::after {
  transform: translate3d(50%, -50%, 0) rotate(135deg);
}

.right {
  right: 0;
  background: linear-gradient(-90deg, var(--color-background, #fff) 5%, rgba(var(--color-background-rgb, 255, 255, 255), 0.65) 75%, rgba(var(--color-background-rgb, 255, 255, 255), 0) 100%);
}
.right::after {
  transform: translate3d(50%, -50%, 0) rotate(-45deg);
}</style>
